module.exports = __webpack_public_path__ + "media/images/desktop/story-script_tap-visual@3x-407c9de47f1005b85125a33a4d48a982.png";